// extracted by mini-css-extract-plugin
export default {"registerMainFrame":"Register_registerMainFrame__CnkP2","submitButton":"Register_submitButton__leAxk","warning":"Register_warning__WJWTG"};